<template>
  <div class="psPatients view">
    <div class="pageContainer">
      <ps-lateral-bar class="lateralBar"></ps-lateral-bar>
        <router-view></router-view>
    </div>
    <el-dialog
      title="Seleccionar enfermedades de base / Momento biológico"
      :visible.sync="dialogDiseases"
      :width="isMobile == true ? '85%' : '40%'"
      :before-close="handleCloseDiseses"
    > 
      <ps-patient-list-diseases></ps-patient-list-diseases>
    </el-dialog>
    <el-dialog
      title="Agregar información eventual"
      :visible.sync="dialogEventuals"
      :width="isMobile == true ? '85%' : '40%'"
      :before-close="handleCloseEventuals"
    > 
      <ps-patient-list-eventuals></ps-patient-list-eventuals>
    </el-dialog>
    <el-dialog
      title="Historia Clínica"
      :visible.sync="dialogMedication"
      :width="isMobile == true ? '85%' : '40%'"
      :before-close="handleCloseMedication"
      v-if="dialogMedication"
    > 
      <ps-patient-medication-detail></ps-patient-medication-detail>
    </el-dialog>
    <el-dialog
      title="Agregar información general"
      :visible.sync="dialogGeneralInformation"
      :width="isMobile == true ? '85%' : '40%'"
      :before-close="handleCloseGeneralInformation"
      v-if="dialogGeneralInformation"
    > 
      <ps-patient-general-information-detail></ps-patient-general-information-detail>
    </el-dialog>
    <el-dialog
      title="Agregar actividad física"
      :visible.sync="dialogPhysicalActivity"
      :width="isMobile == true ? '85%' : '40%'"
      :before-close="handleClosePhysicalActivity"
      v-if="dialogPhysicalActivity"
    > 
      <ps-patient-physical-activity-detail></ps-patient-physical-activity-detail>
    </el-dialog>
    <el-dialog
      title="Agregar actividad de resumen mensual"
      :visible.sync="dialogWeekend"
      :width="isMobile == true ? '85%' : '40%'"
      :before-close="handleCloseWeekend"
      v-if="dialogWeekend"
    > 
      <ps-patient-weekend-detail></ps-patient-weekend-detail>
    </el-dialog>
    <el-dialog
      title="Suscripción"
      :visible.sync="dialogSubscription"
      :width="isMobile == true ? '85%' : '50%'"
      :before-close="handleCloseSubscription"
      v-if="dialogSubscription"
    > 
      <ps-patient-subscription-detail></ps-patient-subscription-detail>
    </el-dialog>
    <el-dialog
      title="Pago"
      :visible.sync="dialogPayment"
      :width="isMobile == true ? '85%' : '50%'"
      :before-close="handleClosePayment"
      v-if="dialogPayment"
    > 
      <ps-patient-payment-detail></ps-patient-payment-detail>
    </el-dialog>
    <el-dialog
      title="Devolución"
      :visible.sync="dialogRefund"
      :width="isMobile == true ? '85%' : '50%'"
      :before-close="handleCloseRefund"
      custom-class="ps-dialog-refund"
      v-if="dialogRefund"
    > 
      <ps-patient-refund-detail></ps-patient-refund-detail>
    </el-dialog>
    <el-drawer
      :visible.sync="drawerAllWeights"
      title="Lista de todos los pesos del paciente"
      direction="rtl"
      :destroy-on-close="true"
      :wrapperClosable="true"
      :before-close="closeListWeights"
      v-if="drawerAllWeights"
    >
      <ps-patient-list-all-weights></ps-patient-list-all-weights>
    </el-drawer>
  </div>
</template>

<script>
import PsPageContainer from '@/components/layout/PsPageContainer.vue'
import PsPatientListDiseases from './pages/PatientsDetail/widgets/PsPatientListDiseases.vue'
import PsPatientListEventuals from './pages/PatientsDetail/widgets/PsPatientListEventuals.vue'
import PsPatientMedicationDetail from './pages/PatientsDetail/widgets/PsPatientMedicationDetail.vue'
import PsPatientGeneralInformationDetail from './pages/PatientsDetail/widgets/PsPatientGeneralInformationDetail.vue'
import PsPatientPhysicalActivityDetail from './pages/PatientsDetail/widgets/PsPatientPhysicalActivityDetail.vue'
import PsPatientWeekendDetail from './pages/PatientsDetail/widgets/PsPatientWeekendDetail.vue'
import PsPatientSubscriptionDetail from './pages/PatientsDetail/widgets/PsPatientSubscriptionDetail.vue'
import PsPatientPaymentDetail from './pages/PatientsDetail/widgets/PsPatientPaymentDetail.vue'
import PsPatientListAllWeights from './pages/PatientsDetail/widgets/PsPatientListAllWeights.vue'
import PsPatientRefundDetail from './pages/PatientsDetail/widgets/PsPatientRefundDetail.vue'
import PsLateralBar from '@/components/layout/PsLateralBar.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PsPatients',
  components: { PsPageContainer, PsPatientListDiseases, PsPatientListEventuals, PsPatientMedicationDetail, PsPatientSubscriptionDetail,
    PsPatientPaymentDetail, PsPatientGeneralInformationDetail, PsPatientListAllWeights, PsPatientRefundDetail, PsPatientPhysicalActivityDetail,
    PsPatientWeekendDetail, PsLateralBar },
  computed: {
    ...mapState('patients', ['dialogDiseases', 'dialogEventuals', 'dialogMedication', 'dialogSubscription', 'dialogPayment', 
      'dialogGeneralInformation', 'drawerAllWeights', 'dialogRefund', 'dialogPhysicalActivity', 'dialogWeekend']),
    ...mapState(['isMobile'])
  },
  methods: {
    ...mapMutations('patients', ['PATIENTS_DIALOG_DISEASES', 'PATIENTS_DIALOG_EVENTUALS', 'PATIENTS_DIALOG_MEDICATION', 
    'PATIENTS_DIALOG_SUBSCRIPTION', 'PATIENTS_SUBSCRIPTION', 'PATIENTS_DIALOG_PAYMENT', 'PATIENTS_PAYMENT', 
    'PATIENTS_DIALOG_GENERAL_INFORMATION', 'PATIENTS_DRAWER_ALL_WEIGHTS', 'PATIENTS_DIALOG_REFUND', 'PATIENTS_DIALOG_PHYSICAL_ACTIVITY',
    'PATIENTS_DIALOG_WEEKEND']),
    handleCloseDiseses () {
      this.PATIENTS_DIALOG_DISEASES(false)
    },
    handleCloseEventuals () {
      this.PATIENTS_DIALOG_EVENTUALS(false)
    },
    handleCloseMedication () {
      this.PATIENTS_DIALOG_MEDICATION(false)
    },
    handleCloseGeneralInformation () {
      this.PATIENTS_DIALOG_GENERAL_INFORMATION(false)
    },
    handleClosePhysicalActivity () {
      this.PATIENTS_DIALOG_PHYSICAL_ACTIVITY(false)
    },
    handleCloseWeekend () {
      this.PATIENTS_DIALOG_WEEKEND(false)
    },
    handleCloseSubscription () {
      this.PATIENTS_SUBSCRIPTION({})
      this.PATIENTS_DIALOG_SUBSCRIPTION(false)
    },
    handleClosePayment () {
      this.PATIENTS_PAYMENT({})
      this.PATIENTS_DIALOG_PAYMENT(false)
    },
    handleCloseRefund () {
      this.PATIENTS_PAYMENT({})
      this.PATIENTS_DIALOG_REFUND(false)
    },
    closeListWeights () {
      this.PATIENTS_DRAWER_ALL_WEIGHTS(false);
    }
  },
  created () {
    this.handleCloseDiseses()
    this.handleCloseEventuals()
    this.handleCloseMedication()
  }
}
</script>

<style scoped>
  :deep(.ps-dialog-refund) {
    background-color: #ffe5e5;
  }

  .pageContainer { width: 100%; height: 100%; display: flex;}
  .dynamicRoute { 
    display: flex; 
    flex-direction: column; 
    z-index: 1; 
    min-height: 90%; 
    background-color: #e1e1e1; 
    width: 94%; 
    min-width: 1200px;
    margin: 16px 16px 0 0; 
    border-radius: 70px 70px 0 0 ;
    padding: 0 50px;
    overflow: hidden;
  }
    
  .lateralBar { width: 6%}

  /* @media (max-width: 575.98px) { ... } */

  /* Small devices (landscape phones, less than 768px) */
  /* @media (max-width: 767.98px) { ... } */

  /* Medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
    .lateralBar { display: none }
    .dynamicRoute { margin: 0; border-radius: 0; width: 100%; min-width: 0; padding: 0 16px}
  }
</style>